import { Grid, Typography } from "@mui/material";
import React from "react";
import theme from "../../utils/theme";
import { Info } from "@mui/icons-material";
import AppButton from "../AppButton";
import { useSelector } from "react-redux";
import { userRoles } from "../../utils/constant";

const styles = {
  root: {
    alignItems: "center",
    background: theme.palette.error.light,
    px: 2,
    py: 1,
    borderRadius: 2,
    mb: 2,
  },
  infoContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  textColor: {
    color: theme.palette.primary.main,
  },
};

const SkipStageComponent = ({ handleSkipStage, loading, stage }) => {
  const { profile } = useSelector((state) => state.profile);
  const role = profile.role;
  return (
    <>
      {((role === userRoles.Quality_Controller_Inspector &&
        !stage.inspector_completed) ||
        (role !== userRoles.Quality_Controller_Inspector &&
          stage.is_skipped)) && (
        <Grid container spacing={2} sx={styles.root}>
          <Grid size={{ xs: 12, md: 8 }} sx={styles.infoContainer}>
            <Info sx={styles.textColor} />
            {stage.is_skipped ? (
              <Typography variant="body2" sx={styles.textColor}>
                This stage has been skipped.
              </Typography>
            ) : (
              <Typography variant="body2" sx={styles.textColor}>
                Clicking this will skip the <b>Second Coat</b> and take you to{" "}
                <b>Top Coat</b>.
              </Typography>
            )}
          </Grid>
          {!stage.is_skipped &&
            role === userRoles.Quality_Controller_Inspector && (
              <Grid size={{ xs: 12, md: 4 }} sx={styles.actionContainer}>
                <AppButton
                  label="Skip Stage"
                  onClick={handleSkipStage}
                  isLoading={loading}
                  buttonType="primary"
                />
              </Grid>
            )}
        </Grid>
      )}
    </>
  );
};

export default SkipStageComponent;
